const initialState = {};

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case "add_user":
      return { ...state, ...action.payload };
    case "remove_user":
      return {};
    case "store_otp":
      return { ...state, otp: action.payload };
    case "remove_otp":
      return { ...state, otp: "" };
    case "change_user":
      return {
        ...state,
        activity_status: action.payload,
      };
    case "getFormFields":
      break;
    default:
      return state;
  }
}
